import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "q-ma-md" }
const _hoisted_2 = { class: "q-px-md full-width" }

import { computed, ref, watch } from "vue";
import { artifactStore } from "@/hooks";
import { ProjectOverviewDisplay } from "@/components/project";
import { PanelCard } from "@/components/common";
import { ArtifactBodyDisplay } from "@/components/artifact";


/**
 * Previews a project after it has been uploaded.
 */
const __default__ = {
  name: "ProjectPreview",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const artifacts = computed(() => artifactStore.allArtifacts);

const artifactId = ref(artifacts.value[0]?.id);

watch(
  artifacts,
  (newArtifacts) => {
    artifactId.value = newArtifacts[0]?.id;
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_q_carousel_slide = _resolveComponent("q-carousel-slide")!
  const _component_q_carousel = _resolveComponent("q-carousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(ProjectOverviewDisplay), { "hide-overflow": "" }),
    _createVNode(_unref(PanelCard), null, {
      default: _withCtx(() => [
        _createVNode(_component_q_carousel, {
          modelValue: artifactId.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((artifactId).value = $event)),
          "transition-prev": "slide-right",
          "transition-next": "slide-left",
          swipeable: "",
          animated: "",
          arrows: "",
          navigation: "",
          height: "400px",
          "control-color": "grey"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(artifacts.value, (artifact) => {
              return (_openBlock(), _createBlock(_component_q_carousel_slide, {
                key: artifact.id,
                name: artifact.id
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_unref(ArtifactBodyDisplay), {
                      "display-title": "",
                      "default-expanded": "",
                      "display-divider": "",
                      "full-width": "",
                      artifact: artifact
                    }, null, 8, ["artifact"])
                  ])
                ]),
                _: 2
              }, 1032, ["name"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    })
  ]))
}
}

})